import React from 'react';
import get from 'lodash/get';
import { Checkbox } from '@paypalcorp/pp-react';
import DonateBox from './donateBox';
import styles from './DonationForm.less';
import { isPPGF } from '../lib/charity';
import * as analytics from '../lib/analytics';

class DonationForm extends React.Component {
  constructor(props) {
    super(props);

    let nonanonymous = true;
    if (get(props.charity, 'address.country_code') === 'GB') {
      nonanonymous = false;
    }

    let charityNpid = props.isGroupDonation
      ? props.charity.groupVirtualNpid
      : props.charity.nonprofit_id;

    this.state = {
      showInputAmountOption: false,
      formURL: `/fundraiser/${this.props.campaignInfo.id}/charity/${charityNpid}/xo/create`,
      captureURL: `/fundraiser/${this.props.campaignInfo.id}/charity/${charityNpid}/xo/execute`,
      nonanonymous,
    };

    this.handleNonAnonymousCheck = this.handleNonAnonymousCheck.bind(this);
    this.renderShareIdentityCheckbox = this.renderShareIdentityCheckbox.bind(
      this
    );
  }

  handleNonAnonymousCheck(event) {
    this.setState({
      nonanonymous: event.target.checked,
    });
  }

  // Need to verify what this logic is about and if we really need it here for a singleCharity Campaign

  renderShareIdentityCheckbox() {
    let campaignInfo = this.props.campaignInfo;
    let numCharities = campaignInfo.charities
      ? campaignInfo.charities.length
      : 0;

    const charity = get(this.props.campaignInfo, 'charities[0]', {});
    if (
      numCharities === 1 &&
      (campaignInfo.state === 'ACTIVE' || campaignInfo.state === 'PREVIEW')
    ) {
      let nonAnonymous;
      if (isPPGF(charity.charity_type)) {
        nonAnonymous = (
          <Checkbox
            className={styles['margin-spacing']}
            label={this.props.i18n('label.non-anonymous')}
            name='non-anonymous'
            onChange={this.handleNonAnonymousCheck}
            value={this.state.nonanonymous}
          />
        );
      }
      return nonAnonymous;
    }
  }

  render() {
    return (
      <DonateBox
        id={this.props.id}
        i18n={this.props.i18n}
        csrf={this.props.csrf}
        enable={this.props.enable}
        eventUrl={this.props.campaignInfo.eventUrl}
        amounts={this.props.amounts}
        anonymousLabel={this.props.i18n('label.non-anonymous')}
        formUrl={this.state.formURL}
        captureUrl={this.state.captureURL}
        charity={this.props.charity}
        fptiInfo={this.props.fptiInfo}
        isGroupDonation={this.props.isGroupDonation}
        cdnHost={this.props.cdnHost}
        {...this.props}
      />
    );
  }
}

export default DonationForm;
